/* Tiloa — relie l'icône panier du header au panier latéral du thème et tient le compteur à jour. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[class^="header-cart-"], a[class*=" header-cart-"]');
    var d = drawer();
    if (!link || !d || typeof d.open !== 'function') return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    d.open(link);
  });

  function links() {
    return document.querySelectorAll('a[class^="header-cart-"], a[class*=" header-cart-"]');
  }

  // Met à jour le badge : nombre, visibilité, libellé lu par les lecteurs
  // d'écran, et petite animation quand la quantité augmente.
  function render(count, animate) {
    links().forEach(function (link) {
      var badge = link.querySelector('[data-cart-count]');
      var value = badge && badge.querySelector('span');
      var label = link.querySelector('[data-cart-count-label]');

      if (value) value.textContent = count > 99 ? '99+' : String(count);
      if (badge) badge.hidden = count === 0;
      if (label) {
        label.textContent = count === 0
          ? 'Panier, vide'
          : 'Panier, ' + count + ' article' + (count > 1 ? 's' : '');
      }

      if (animate && count > 0) {
        link.classList.remove('is-bumping');
        // Forcer un reflow pour pouvoir rejouer l'animation.
        void link.offsetWidth;
        link.classList.add('is-bumping');
        setTimeout(function () { link.classList.remove('is-bumping'); }, 420);
      }
    });
  }

  var last = null;

  function appliquer(count) {
    var animate = last !== null && count > last;
    last = count;
    render(count, animate);
  }

  /* Le compteur etait redemande a /cart.js apres chaque ajout — un
     aller-retour reseau entier, mesure a 149 ms, juste pour lire un nombre que
     la reponse precedente contenait deja. L'evenement « cartUpdate » porte
     cette reponse, sous deux formes selon le chemin :

       - depuis le panier lateral (quantite modifiee, ligne retiree), cartData
         est le panier complet : item_count est la, directement ;
       - depuis une fiche produit, cartData est la ligne ajoutee — pas le
         panier — mais le formulaire demande a Shopify de rendre en meme temps
         la section « cart-icon-bubble », et ce fragment porte le total.

     Deux lectures, zero requete. La requete ne subsiste que pour le cas ou
     aucune des deux formes n'est la : mieux vaut un aller-retour qu'un
     compteur faux. */
  function compteurDansSections(c) {
    var html = c && c.sections && c.sections['cart-icon-bubble'];
    if (typeof html !== 'string') return null;
    var frag = new DOMParser().parseFromString(html, 'text/html');
    var bulle = frag.querySelector('.cart-count-bubble span[aria-hidden]');
    /* Panier vide : Liquid n'ecrit pas la bulle du tout. C'est zero, pas une
       absence de mesure. Une bulle presente mais illisible, en revanche, reste
       une absence : on ne devine pas. */
    if (!bulle) return frag.querySelector('.cart-count-bubble') ? null : 0;
    var n = parseInt((bulle.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  function refreshCount(evenement) {
    var c = evenement && evenement.cartData;
    if (c && typeof c.item_count === 'number') return appliquer(c.item_count);

    var n = compteurDansSections(c);
    if (n !== null) return appliquer(n);

    fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { appliquer(cart.item_count); })
      .catch(function () {});
  }

  // Valeur de départ, lue dans le DOM rendu par Liquid.
  (function readInitial() {
    var badge = document.querySelector('[data-cart-count] span');
    if (!badge) return;
    var n = parseInt(badge.textContent, 10);
    if (!isNaN(n)) last = n;
  })();

  if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }
  document.addEventListener('tiloa:cart-refresh', function () { refreshCount(null); });

  /* Retour navigateur : le seul cas où redemander le panier se justifie.

     Mesuré sur le parcours pré-vente → fiche → ajout → retour : le panier
     contenait bien deux articles, et le compteur du header affichait zéro. Le
     navigateur restitue la page depuis son cache avant/arrière, exactement
     telle qu'elle était avant l'ajout — badge compris. Aucun événement du
     thème ne se déclenche, puisque rien n'a bougé dans cette page-là.

     Le client voit donc un panier vide après y avoir mis deux produits. Ici,
     un aller-retour réseau vaut mieux qu'un compteur faux : il ne coûte rien
     au chemin d'achat, puisqu'il n'arrive qu'au retour.

     Deux chemins mènent à ce défaut, et il faut les couvrir tous les deux.
     « persisted » ne vaut que pour le cache avant/arrière, et le navigateur
     ne s'en sert pas toujours : mesuré sur ce même parcours, le retour a
     rechargé la page depuis le cache HTTP, persisted à faux, et le compteur
     est resté faux. Le type de navigation, lui, dit « back_forward » dans les
     deux cas. */
  function retourArriere() {
    try {
      var n = performance.getEntriesByType('navigation')[0];
      return !!n && n.type === 'back_forward';
    } catch (e) { return false; }
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted || retourArriere()) refreshCount(null);
  });

  /* ---- Retour visuel au clic « Passer au paiement » -------------------
     Le clic declenche la navigation en 33 ms — ce n'est pas la le probleme.
     Mais le checkout Shopify met environ une seconde a s'afficher, et pendant
     cette seconde le navigateur laisse l'ancienne page a l'ecran, inchangee.
     Rien ne bouge : le visiteur croit que son clic n'a pas ete pris.

     On ne ralentit donc rien. On ne fait qu'ecrire, dans le meme battement que
     le clic, que la demande est partie — et on verrouille le bouton pour que
     deux clics ne creent pas deux checkouts.

     Aucun preventDefault, aucune attente, aucune requete : la navigation part
     exactement comme avant. */
  (function attenteCheckout() {
    var LIBELLE = 'Ouverture du paiement…';

    function marquer(btn) {
      if (!btn || btn.dataset.tiloaEnCours) return;
      btn.dataset.tiloaEnCours = '1';
      btn.dataset.tiloaTexte = btn.innerHTML;
      btn.classList.add('tiloa-checkout-attente');
      btn.setAttribute('aria-busy', 'true');
      // On ecrit le libelle sans toucher a la largeur du bouton : un bouton
      // qui retrecit sous le doigt donne l'impression d'un bug.
      btn.style.minWidth = btn.offsetWidth + 'px';
      btn.innerHTML = '<span class="tiloa-spin" aria-hidden="true"></span>' + LIBELLE;

      /* Si la navigation n'a pas eu lieu, on rend le bouton. Trois secondes,
         parce qu'un bouton mort apres un echec reseau est pire que lent. */
      setTimeout(function () { rendre(btn); }, 3000);
      window.addEventListener('pageshow', function () { rendre(btn); }, { once: true });
    }

    function rendre(btn) {
      if (!btn || !btn.dataset.tiloaEnCours) return;
      delete btn.dataset.tiloaEnCours;
      btn.classList.remove('tiloa-checkout-attente');
      btn.removeAttribute('aria-busy');
      if (btn.dataset.tiloaTexte) btn.innerHTML = btn.dataset.tiloaTexte;
    }

    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"], [data-analytics-action="checkout"]')
        : null;
      if (!b || b.disabled) return;
      marquer(b);
    }, { capture: true, passive: true });
  })();
})();
